import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showError, showSuccess } from "utils/notifications";
import { loginUser } from "adminApi/AuthenticationApi/Login";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);



  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await loginUser(
        email,
        password
      );

      const {
        success,
        message,
        data,
      } = response || {};

      // ==========================================
      // LOGIN FAILED
      // ==========================================

      if (!success) {
        showError(
          message || "Login failed"
        );

        return;
      }

      // ==========================================
      // LOGIN DATA
      // ==========================================

      const {
        accessToken,
        refreshToken,
        user,
      } = data || {};

      if (!accessToken || !refreshToken) {
        showError(
          "Login failed: authentication tokens are missing"
        );

        return;
      }

      // ==========================================
      // STORE TOKENS
      // ==========================================

      localStorage.setItem(
        "accessToken",
        accessToken
      );

      localStorage.setItem(
        "refreshToken",
        refreshToken
      );

      // ==========================================
      // REDUX USER ONLY
      // ==========================================

      dispatch({
        type: "LOGIN_SUCCESS",
        payload: {
          user,
        },
      });

      // ==========================================
      // SUCCESS
      // ==========================================

      showSuccess(
        message || "Login successful"
      );

      navigate("/index", {
        replace: true,
      });
    } catch (err) {
      // ==========================================
      // ERROR MESSAGE
      // ==========================================

      showError(
        err?.response?.data?.message ||
        err?.data?.message ||
        err?.message ||
        "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="px-xl-5 px-2 auth-body">
      <form onSubmit={handleLogin}>
        <ul className="row g-3 list-unstyled li_animate">
          <li className="col-12">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              className="form-control form-control-lg"
              placeholder="Enter email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </li>
          <li className="col-12">
            <div className="form-label">
              <span className="d-flex justify-content-between align-items-center">
                Password
                {/* <Link className="text-primary" to="/password-reset">
                  Forgot Password?
                </Link> */}
              </span>
            </div>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                className="form-control form-control-lg pe-5"
                placeholder="Enter password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <i className="bi bi-eye"></i>
                ) : (
                  <i className="bi bi-eye-slash"></i>
                )}
              </button>
            </div>
          </li>
          <li className="col-12">
            <div className="form-check fs-5">
              <input
                className="form-check-input"
                type="checkbox"
                id="Rememberme"
              />
              <label className="form-check-label fs-6" htmlFor="Rememberme">
                Remember me
              </label>
            </div>
          </li>
          <li className="col-12 mt-lg-4">
            <button
              type="submit"
              className="btn btn-lg w-100 btn-primary text-uppercase mb-2"
              title="sign in"
              disabled={loading}
            >
              {loading ? <>loading... <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span></> : "SIGN IN"}
            </button>
          </li>


        </ul>
      </form>
    </div>
  );
};

export default Signin;
